import axios from 'axios'
import { ref } from 'vue'
import { defineStore } from 'pinia'
import { castAttributesForCamelCase } from 'src/biz_spa/modules/string_converter'
import type { AxiosResponse } from 'axios'

export type Setup = {
  storeUuid: string
  yahooMediaLibrary?: boolean
}

export type SetupResponse = {
  store_uuid: string
  yahoo_media_library: boolean
}

export type SetupsAPIResponse = {
  data: SetupResponse[]
}

export const useLocationStoreSetupsStore = defineStore('locationStoreSetups', () => {
  const setups = ref<Setup[]>([])

  const readStoreSetups = async (companyUuid: string, storeUuid?: string[]): Promise<Setup[]> => {
    const response = await axios.get<unknown, AxiosResponse<SetupsAPIResponse>>(`/api/companies/${companyUuid}/stores/setups`, {
      params: storeUuid && storeUuid.length ? { uuid: storeUuid } : undefined
    })
    setups.value = response.data.data.map((data) => castAttributesForCamelCase(data)) as Setup[]
    return setups.value
  }

  const findStoreSetup = (storeUuid: string): Setup | null => {
    return setups.value.find((setup) => setup.storeUuid === storeUuid) || null
  }

  return {
    setups,
    readStoreSetups,
    findStoreSetup,
  }
})
